/**
 * WCAG 2.4.1 (Bypass Blocks): first tabbable element on every page; invisible
 * until keyboard-focused, then jumps focus past the chrome to the active
 * surface's `<main id="main-content" tabIndex={-1}>` region. Keyboard and
 * screen-reader users skip the header/sidebar on every page load instead of
 * tabbing through it.
 *
 * Focus is moved explicitly on activation rather than relying on fragment
 * navigation — browsers are inconsistent about moving focus on hash jumps
 * (Safari never does), which would leave the skip link a silent no-op.
 */
export function SkipToMainLink() {
  return (
    <a
      href="#main-content"
      onClick={(event) => {
        const main = document.getElementById('main-content');
        if (!main) return; // rare route without a main region — let the browser try
        event.preventDefault();
        main.focus();
        // Scroll is a progressive enhancement (jsdom has no scrollIntoView).
        if (typeof main.scrollIntoView === 'function') main.scrollIntoView();
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-100 focus:rounded-md focus:bg-primary focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-lg"
    >
      Skip to main content
    </a>
  );
}
